'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _Fieldset2 = require('./Fieldset');

var _Fieldset3 = _interopRequireDefault(_Fieldset2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tbody = (_temp = _class = function (_Fieldset) {
  (0, _inherits3.default)(Tbody, _Fieldset);

  function Tbody() {
    (0, _classCallCheck3.default)(this, Tbody);
    return (0, _possibleConstructorReturn3.default)(this, _Fieldset.apply(this, arguments));
  }

  return Tbody;
}(_Fieldset3.default), _class.defaultProps = (0, _extends3.default)({}, _Fieldset3.default.defaultProps, {
  tagName: 'tbody'
}), _temp);
exports.default = Tbody;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Tbody.js
 ** module id = 1281
 ** module chunks = 0
 **/